import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormGroup } from '@theneatcompany/nui'

const FieldError = ({
  label,
  message,
  touched,
  ignoreTouched,
  onRender,
  className,
  alwaysPresent,
  ...rest
}) => {
  if (!message && !alwaysPresent) return null
  const defaultMessage = label ? `${label} ${message}` : message
  const errorMessage = onRender ? onRender(label, message) : defaultMessage

  // @TODO Consider using a placeholder element instead when alwaysPresent is true
  return (touched || ignoreTouched || alwaysPresent) && (
    <FormGroup.HelperText className={cx(className, alwaysPresent && 'always-present')} role="alert" {...rest}>
      {message ? errorMessage : ''}
    </FormGroup.HelperText>
  )
}

FieldError.defaultProps = {
  label: null,
  message: null,
  onRender: null,
  touched: false,
  ignoreTouched: true,
  className: null,
  alwaysPresent: false,
}

FieldError.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  message: PropTypes.string,
  onRender: PropTypes.func,
  touched: PropTypes.bool,
  ignoreTouched: PropTypes.bool,
  className: PropTypes.string,
  alwaysPresent: PropTypes.bool,
}

export default FieldError
